import { createSchema } from '~/lib/useQueryParameter';
import { StaticProps } from '../../context';
import { CourseMappingsSearchQuery } from '../../data/useCourseMappings';
import { pageNumberParameter } from './pageNumberParameter';
import { pageSizeParameter } from './pageSizeParameter';
import { archivedFilter } from './archivedFilter';
import { countryFilter } from './countryFilter';
import { sortParameter } from './sortParameter';

export type Parameters = {
  pageNumber: number;
  pageSize: number;
  archived: string | undefined;
  country: string[];
  sort: string;
};

export const schema = createSchema<StaticProps, CourseMappingsSearchQuery, Parameters>({
  pageNumber: pageNumberParameter,
  pageSize: pageSizeParameter,
  archived: archivedFilter,
  country: countryFilter,
  sort: sortParameter,
});
